const CertificateView = ({
  id,
  className,
  studentInfo,
  courseInfo,
  content,
  date,
  logo,
  signature,
  imgLoad,
  setLoaded,
}) => {
  const handleLoad = (e) => {
    setLoaded(true);
    let canvas = document.getElementById("logo_canvas");
    canvas.width = e.target.width;
    canvas.height = e.target.height;
    let ctx = canvas.getContext("2d");
    ctx.drawImage(e.target, 0, 0, e.target.width, e.target.height);
  };
  return (
    <div
      id={id || "cert_cvs"}
      className={`w-[826px] h-[1169px] ${className}`}
      style={{ fontFamily: "serif" }}
    >
      <div className="outer-border bg-white">
        <div className="mid-border">
          <div className="inner-border">
            <img
              className="corner-decoration corner-left-top"
              src="/corner-decoration.png"
              alt="frame"
            />
            <img
              className="corner-decoration corner-right-top"
              src="/corner-decoration.png"
              alt="frame"
            />
            <img
              className="corner-decoration corner-right-bottom"
              src="/corner-decoration.png"
              alt="frame"
            />
            <img
              className="corner-decoration corner-left-bottom"
              src="/corner-decoration.png"
              alt="frame"
            />
            <div className="flex flex-col w-[80%] my-20 m-auto h-full justify-between gap-12">
              <div className="relative h-[160px]">
                <hr className="left-0 right-0 top-0 absolute border-2 border-black" />
                <h1 className="text-[5.5rem] uppercase left-0 right-0 top-0 absolute text-center">
                  certificate
                </h1>
                <h3 className="text-[2.5rem] uppercase left-0 right-0 bottom-0 absolute text-center">
                  of completion
                </h3>
                <hr className="left-0 right-0 bottom-0 absolute border-2 border-black" />
              </div>
              <div className="flex flex-col gap-12 flex-1">
                <table className="text-lg table-auto border-spacing-1 border-separate self-start">
                  <tbody>
                    {studentInfo &&
                      studentInfo.map(
                        ([label, value]) =>
                          value && (
                            <tr key={`student_${label}`}>
                              <td>
                                <div className="w-full inline-flex justify-between">
                                  {label.split("").map((char, i) => (
                                    <span key={`student_${i}_${char}`}>
                                      {char}
                                    </span>
                                  ))}
                                </div>
                              </td>
                              <td>:</td>
                              <td className="pl-2 text-shadow">{value}</td>
                            </tr>
                          )
                      )}
                  </tbody>
                </table>
                <table className="text-xl table-auto border-spacing-1 border-separate self-center">
                  <tbody>
                    {courseInfo &&
                      courseInfo.map(([label, value]) => (
                        <tr key={`info_${label}`}>
                          <td>
                            <div className="w-full inline-flex justify-between">
                              {label.split("").map((char, i) => (
                                <span key={`info_${i}_${char}`}>{char}</span>
                              ))}
                            </div>
                          </td>
                          <td>:</td>
                          <td className="pl-2 text-shadow">{value}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                <div>
                  {content.map((v, i) => (
                    <p
                      className="text-2xl text-center leading-9"
                      key={`content_${i}`}
                    >
                      {v}
                    </p>
                  ))}
                </div>
              </div>
              <div className="flex flex-col gap-8 items-center">
                <p className="text-2xl text-center leading-9">{date}</p>
                <div className="inline-flex w-fit gap-6">
                  {logo && (
                    <div className="flex-auto text-end">
                      <img
                        src={logo}
                        alt="수료증 로고"
                        onLoad={handleLoad}
                        id="logo_img"
                        crossOrigin="anonymous"
                        className={imgLoad ? "hidden" : ""}
                      />
                      <canvas
                        id="logo_canvas"
                        className={!imgLoad ? "hidden" : ""}
                      />
                    </div>
                  )}
                  {signature && (
                    <div className="flex flex-row items-center gap-4 text-xl flex-auto justify-end">
                      <span>{signature.position}</span>
                      <span className="text-3xl">{signature.name}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CertificateView;
